/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderResponseDTOFromJSON, OrderResponseDTOToJSON, } from './OrderResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseOrderResponseDTO interface.
 */
export function instanceOfPaginatedResponseOrderResponseDTO(value) {
    return true;
}
export function PaginatedResponseOrderResponseDTOFromJSON(json) {
    return PaginatedResponseOrderResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseOrderResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(OrderResponseDTOFromJSON)),
    };
}
export function PaginatedResponseOrderResponseDTOToJSON(json) {
    return PaginatedResponseOrderResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseOrderResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(OrderResponseDTOToJSON)),
    };
}
